import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material';
import { ERROR, PRIMARY, SECONDARY, SUCCESS, WARNING } from './constants/Colors';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

let theme = createTheme({
  palette: {
    primary: { main: PRIMARY },
    secondary: { main: SECONDARY },
    success: { main: SUCCESS },
    error: { main: ERROR },
    warning: { main: WARNING }
  },
  typography: {
    allVariants: {
      fontFamily: 'Roboto, sans-serif',
      lineHeight: 1.2,
      fontSize: '0.95rem',
      letterSpacing: 'normal'
    },
    button: {
      fontSize: '0.95rem'
    }
  },

  components: {
    // MuiOutlinedInput: {
    // 	styleOverrides: {
    // 		root: {
    // 			"& .MuiOutlinedInput-notchedOutline": {
    // 				borderWidth: 0,
    // 			},
    // 		},
    // 	},
    // },
  }
});

theme = responsiveFontSizes(theme);

root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
